import Header from "../components/Header";
import Spinner from "../components/Spinner";
import MobileNav from "components/MobileNav";
import {
  createContext,
  Suspense,
  useContext,
  useEffect,
  useState,
} from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "components/Sidebar";

const ModalContext = createContext();

export const useModal = () => useContext(ModalContext);

export default function MainLayout() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  // Start closed on mobile, open on desktop
  const [isSidebarOpen, setIsSidebarOpen] = useState(() => window.innerWidth >= 768);

  const toggleMenu = () => setIsMenuOpen((prev) => !prev);
  const closeMenu = () => setIsMenuOpen(false);

  useEffect(() => {
    document.body.style.overflow = isMenuOpen ? "hidden" : "auto";
    return () => { document.body.style.overflow = "auto"; };
  }, [isMenuOpen]);

  useEffect(() => {
    if (isSuccess) {
      const t = setTimeout(() => setIsSuccess(false), 5000);
      return () => clearTimeout(t);
    }
  }, [isSuccess]);

  // Close sidebar when resizing down to mobile
  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth < 768) setIsSidebarOpen(false);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return (
    <ModalContext.Provider value={{ toggleMenu, closeMenu }}>
      <div className="relative bg-light_brand_primary h-[100vh]">
        <Suspense fallback={<Spinner />}>
          <div className="flex h-screen bg-neutral_disabled overflow-hidden">
            <Sidebar
              isOpen={isSidebarOpen}
              toggle={() => setIsSidebarOpen((prev) => !prev)}
            />

            <div className="flex-1 min-w-0 flex flex-col">
              <Header toggleSidebar={() => setIsSidebarOpen((prev) => !prev)} />

              <main
                className="flex-1 w-full overflow-y-auto p-4 md:p-6 pb-20 md:pb-6 bg-white"
                style={{ height: "calc(100vh - 90px)" }}
              >
                <Outlet />
              </main>
            </div>
          </div>
        </Suspense>

        {/* Bottom nav for mobile */}
        <MobileNav />
      </div>
    </ModalContext.Provider>
  );
}
